import { NgFor, NgIf } from '@angular/common';
import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { CardComponent } from '@domgen/dgx-fe-components/card';
import { PictureComponent } from '@domgen/dgx-fe-components/media';
import { FindApplianceModelNumber } from '@us-registration/util-models';

@Component({
  selector:
    'us-registration-appliance-details-stepped-wib-form-find-model-serial-panel',
  standalone: true,
  imports: [CardComponent, NgFor, NgIf, PictureComponent],
  templateUrl:
    './appliance-details-stepped-wib-form-find-model-serial-panel.component.html',
  styleUrls: [
    './appliance-details-stepped-wib-form-find-model-serial-panel.component.scss',
  ],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ApplianceDetailsSteppedWibFormFindModelSerialPanelComponent {
  @Input() appliance: string | undefined;
  @Input() modelNumberFinderContent: FindApplianceModelNumber | undefined;
}
